import { render, staticRenderFns } from "./ContractDocumentTable.vue?vue&type=template&id=13afe3d8&"
import script from "./ContractDocumentTable.vue?vue&type=script&lang=ts&"
export * from "./ContractDocumentTable.vue?vue&type=script&lang=ts&"
import style0 from "./ContractDocumentTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports